import store from '@/store'
import base64 from 'base-64'
import axios from 'axios'
import appConfig from '@/service/config'
import un from 'underscore'
import uns from "underscore.string"
var images = require.context('../assets/', false, /\.png$/)

const userService = {
  getAuthHeader: function () {
    return store.state.userData.httpHeader
  },
  logUser: function (login, password) {
    var encoded = base64.encode(login + ':' + password)
    return axios({
      method: 'post',
      url: appConfig.baseUrl + '/users/checkUser',
      data: {},
      headers: {
        checkUser: 'Basic ' + encoded
      }
    })
  },
  checkLoggedUser: function() {
    return axios({
      method: 'post',
      url: appConfig.baseUrl + '/users/checkUser',
      data: {},
      headers: {
        checkUser: store.state.userData.httpHeader
      }
    })
  },
  saveUser: function (user) {
    store.commit('logUser', {
      user: user
    })
  },
  getCurrentUser: function () {
    return store.state.userData;
  },
  saveCurrentStore: function (storeId) {
    store.commit('storeId', {'storeId': storeId})
  },
  getCurrentStore: function () {
    return store.state.storeId;
  },
  logOut: function () {
    store.commit('logout')
  },
  isLogged: function () {
    return store.state.userData.logged
  },
  isNotLogged: function () {
    return !this.isLogged()
  },
  isAdmin: function() {
    const adminRole = "ROLE_ADMIN";
    return un.indexOf(store.state.userData.permissions,adminRole) !== -1;
  },
  isUser: function() {
    const userRole = "ROLE_USER";
    return un.indexOf(store.state.userData.permissions,userRole) !== -1;
  },
  isUserPhoneServices: function() {
    const role = "ROLE_PHONE_SERVICES";
    return un.indexOf(store.state.userData.permissions,role) !== -1;
  },
  getUserPermissions() {
    return store.state.userData.permissions
  },
  getAvatarUrl: function() {
    var imgName = "male-avatar.png";
    const user = userService.getCurrentUser();
    const userName = user.userInfo.userName;
    if (userName && uns.endsWith(userName, "a")) {
      imgName = "female-avatar.png";
    }
    return images("./" + imgName);
  }
}

export default userService



// WEBPACK FOOTER //
// ./src/service/userService.js